import React, { Component, useState } from "react";

import { Row, Col, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { API_URL } from "../../../constants";
import useAxios from "@use-hooks/axios";
import moment from "jalali-moment";
// CSS Files
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/Responsibility/Responsibility.css";

const titleHr = {
  border: ".009em solid #e13024",
  width: "100%",
  marginTop: "-10px",
  direction: "rtl",
  textAlign: "right",
};

const ResponsibilityInsideImg = {
  width: "75%",
  height: "auto",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
};
const ResponsibilityInside = (props) => {
  const [responsibility, setResponsibility] = useState([]);

  const getResponsibility = useAxios({
    url: `${API_URL}/Social_Responsibility_Service/${props.id}`,
    trigger: [],
    customHandler: (err, res) => {
      if (res) {
        console.log("data", res.data);
        setResponsibility(res.data);
      }
    },
  });

  return props.size === "laptopdesktop" ? (
    <div className="ResponsibilityInsideBackground">
      <div style={{ paddingTop: "100px" }}>
        <Center>
          <p className="mainTitle mainTitleBorderRight mainTitleBorderLeft">
            <strong>مسئولیت های اجتماعی</strong>
          </p>
        </Center>
      </div>
      <Row style={{ marginTop: "75px" }}>
        <Col span={4}></Col>
        <Col span={16}>
          {getResponsibility.response?.data && (
            <Card
              style={{
                borderRadius: "20px",
                backgroundColor: "#fff",
                opacity: "95%",
              }}
            >
              <Row>
                {/* <Col span={6}>
                  <p
                    style={{
                      fontFamily: "IranSans",
                      fontSize: ".9em",
                      color: "#3d5563",
                      padding: "20px",
                      direction: "ltr",
                      textAlign: "left",
                      marginLeft: "5px",
                      paddingTop: 0,
                    }}
                  >
                    {moment(responsibility.date, "YYYY/MM/DD")
                      .locale("fa")
                      .format("YYYY/MM/DD")}
                  </p>
                </Col> */}
                <Col span={24}>
                  <p
                    style={{
                      fontSize: ".95em",
                      fontFamily: "IranSans",
                      color: "#174561",
                      textAlign: "right",
                      direction: "rtl",
                      paddingBottom: 0,
                    }}
                  >
                    <strong>{responsibility.title}</strong>
                  </p>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <hr style={titleHr} />

                </Col>
              </Row>
              <div style={{ backgroundColor: "#fff" }}>
                <p className="textParagraph">{responsibility.description}</p>
              </div>
              <Margin top={3}></Margin>
              {responsibility.social_images.map((item, index) => {
                return [
                  <>
                    <Center key={index}>
                      <img style={ResponsibilityInsideImg} src={item.image} />
                    </Center>
                    <Margin top={3}></Margin>
                  </>,
                ];
              })}
            </Card>
          )}
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
      <div className="ResponsibilityInsideBackground">
        <div style={{ paddingTop: "75px" }}>
          <Center>
            <p className="mainTitleTablet mainTitleBorderRight mainTitleBorderLeft">
              <strong style={{ padding: "15px" }}>مسئولیت های اجتماعی</strong>
            </p>
          </Center>
        </div>
        <Row style={{ marginTop: "75px" }}>
          <Col span={2}></Col>
          <Col span={20}>
            {getResponsibility.response?.data && (
              <Card
                style={{
                  borderRadius: "20px",
                  backgroundColor: "#fff",
                  opacity: "95%",
                }}
              >
                <Row>
                  {/* <Col span={6}>
                    <p
                      style={{
                        fontFamily: "IranSans",
                        fontSize: ".85em",
                        color: "#3d5563",
                        padding: "20px",
                        direction: "ltr",
                        textAlign: "left",
                        marginLeft: "5px",
                        paddingTop: 0,
                      }}
                    >
                      {moment(responsibility.date, "YYYY/MM/DD")
                        .locale("fa")
                        .format("YYYY/MM/DD")}
                    </p>
                  </Col> */}
                  <Col span={24}>
                    <p
                      style={{
                        fontSize: ".9em",
                        fontFamily: "IranSans",
                        color: "#174561",
                        textAlign: "right",
                        direction: "rtl",
                        paddingBottom: 0,
                      }}
                    >
                      <strong>{responsibility.title}</strong>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <hr style={titleHr} />
                </Row>
                <div style={{ backgroundColor: "#fff" }}>
                  <p className="textParagraphTablet">{responsibility.description}</p>
                </div>
                <Margin top={3}></Margin>
                {responsibility.social_images.map((item, index) => {
                  return [
                    <>
                      <Center key={index}>
                        <img style={ResponsibilityInsideImg} src={item.image} />
                      </Center>
                      <Margin top={3}></Margin>
                    </>,
                  ];
                })}
              </Card>
            )}
            <Margin bottom={4}></Margin>
          </Col>
          <Col span={2}></Col>
        </Row>
      </div>


  ) : (
        <div className="ResponsibilityInsideBackground">
          <div style={{ paddingTop: "50px" }}>
            <Center>
              <p className="mainTitleMobile mainTitleBorderRightMobile mainTitleBorderLeftMobile">
                <strong>مسئولیت های اجتماعی</strong>
              </p>
            </Center>
          </div>
          <Row style={{ marginTop: "50px" }}>
            <Col span={1}></Col>
            <Col span={22}>
              {getResponsibility.response?.data && (
                <Card
                  style={{
                    borderRadius: "20px",
                    backgroundColor: "#fff",
                    opacity: "95%",
                  }}
                >
                  <Row>
                    {/* <Col span={6}>
                      <p
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".75em",
                          color: "#3d5563",
                          padding: "20px",
                          direction: "ltr",
                          textAlign: "left",
                          marginLeft: "5px",
                          paddingTop: 0,
                        }}
                      >
                        {moment(responsibility.date, "YYYY/MM/DD")
                          .locale("fa")
                          .format("YYYY/MM/DD")}
                      </p>
                    </Col> */}
                    <Col span={24}>
                      <p
                        style={{
                          fontSize: ".8em",
                          fontFamily: "IranSans",
                          color: "#174561",
                          textAlign: "right",
                          direction: "rtl",
                          paddingBottom: 0,
                        }}
                      >
                        <strong>{responsibility.title}</strong>
                      </p>
                      
                    </Col>
                  </Row>
                  <Row>
                    <Col span={24}>
                      <hr style={titleHr} />
                    </Col>
                  </Row>
                  <div style={{ backgroundColor: "#fff" }}>
                    <p className="textParagraphMobile">{responsibility.description}</p>
                  </div>
                  <Margin top={3}></Margin>
                  {responsibility.social_images.map((item, index) => {
                    return [
                      <>
                        <Center key={index}>
                          <img style={ResponsibilityInsideImg} src={item.image} />
                        </Center>
                        <Margin top={3}></Margin>
                      </>,
                    ];
                  })}
                </Card>
              )}
              <Margin bottom={4}></Margin>
            </Col>
            <Col span={1}></Col>
          </Row>
        </div>
  );
};

export default ResponsibilityInside;
